import { RootState } from '@store/redux/store';

export function selectDevice() {
  return (reduxState: RootState) => {
    return reduxState.mobileStore.deviceType;
  };
}
export function selectViewport() {
  return (reduxState: RootState) => {
    return reduxState.mobileStore.viewport;
  };
}
export function checkDevice() {
  return (reduxState: RootState) => {
    const { deviceType } = reduxState.mobileStore;
    const isMobile = deviceType === 'mobile';
    const isDesktop = deviceType === 'desktop';
    return { isMobile, isDesktop };
  };
}
